import palette from 'google-palette'

import Multiselect from 'vue-multiselect'
import PieChart from '../components/charts/PieChart'
import BarChart from '../components/charts/BarChart'
import MomentDatePicker from '../components/MomentDatePicker'
import FilterMixin from './FilterMixin'

var DashboardMixin = {
  mixins: [FilterMixin],
  data() {
    return {
      filterVisible: false,
      emptyGraph: {
        data: {
          labels: [],
          datasets: [
            {
              label: 'No data',
              data: [],
              backgroundColor: [],
            },
          ],
        },
        options: {maintainAspectRatio: false},
      },
      barChartStackedOptions: {
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true,
            },
          ],
          yAxes: [
            {
              stacked: true,
              display: true,
            },
          ],
        },
      },
      barChartStackedMoneyOptions: {
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]

              var formatter = new Intl.NumberFormat('fr-CA', {
                style: 'currency',
                currency: 'CAD',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })
              return data.datasets[tooltipItem.datasetIndex].label + ' - ' + formatter.format(value)
            },
          },
        },
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true,
            },
          ],
          yAxes: [
            {
              stacked: true,
              display: true,
              ticks: {
                beginAtZero: true, // minimum value will be 0.
                callback: function(value, index, values) {
                  var formatter = new Intl.NumberFormat('fr-CA', {
                    style: 'currency',
                    currency: 'CAD',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })
                  return formatter.format(value)
                },
              },
            },
          ],
        },
      },
    }
  },
  created: function() {
    this.fetchData()
  },
  methods: {
    generateBarStackedChartFromData: function(data, translation, money, ...fields) {
      if (money == null) money = false
      let labels = _.map(data, 'key')

      let colors = _.map(palette('mpn65', labels.length + 1), f => '#' + f)

      let dataSet = []
      _.forIn(fields, (each, index) =>
        dataSet.push({
          label: this.$t(translation + '.' + each + '.acronym'),
          data: _.map(data, each),
          backgroundColor: Array.apply(null, {length: labels.length + 1}).map(f => colors[index]),
        })
      )

      return {
        data: {
          labels: labels,
          datasets: dataSet,
        },
        options: money ? this.barChartStackedMoneyOptions : this.barChartStackedOptions,
      }
    },
    generateBarChartFromData: function(data, translation, money, ...fields) {
      if (money == null) money = false
      let labels = _.map(data, 'key')

      let colors = _.map(palette('mpn65', labels.length + 1), f => '#' + f)

      let dataSet = []
      _.forIn(fields, (each, index) =>
        dataSet.push({
          label: this.$t(translation + '.' + each + '.acronym'),
          data: _.map(data, each),
          backgroundColor: Array.apply(null, {length: labels.length + 1}).map(f => colors[index]),
        })
      )

      return {
        data: {
          labels: labels,
          datasets: dataSet,
        },
        options: {
          maintainAspectRatio: false,
        },
      }
    },
    getDateTimeGroupFormat: function(data, dateField) {
      let minData = _.minBy(data, dateField)[dateField]
      let maxData = _.maxBy(data, dateField)[dateField]
      let diffData = maxData.diff(minData, 'days')

      let groupFormat = 'YYYY'
      if (diffData <= 30) groupFormat = 'DD-MM-YYYY'
      else if (diffData <= 500) groupFormat = 'MM-YYYY'

      return groupFormat
    },
    getChartCountDataIfNotEmpty: function(field, sumField) {
      let data = _.chain(this.filteredData)
        .groupBy(field)
        .map((items, key) => ({key: key, sum: _.sumBy(items, s => (s[sumField] != null && s[sumField] != 0 ? 1 : 0))}))
        .orderBy(o => o.key)
        .value()
      let labels = _.map(data, 'key')
      let dataSet = _.map(data, 'sum')

      return this.setChartData(labels, dataSet)
    },
    getChartMeanData: function(field, sumField, list) {
      let filteredData = this.filteredData
      if (list != null) filteredData = list

      let data = _.chain(list)
        .groupBy(field)
        .map((items, key) => ({key: key, mean: _.meanBy(items, sumField).toFixed(2)}))
        .orderBy(o => o.key)
        .value()
      let labels = _.map(data, 'key')
      let dataSet = _.map(data, 'mean')

      return this.setChartData(labels, dataSet, true)
    },
    getChartSumData: function(field, sumField, money, specificData) {
      if (specificData == null) specificData = this.filteredData
      let data = _.chain(specificData)
        .groupBy(field)
        .map((items, key) => ({key: key, sum: _.sumBy(items, sumField).toFixed(2)}))
        .orderBy(o => o.key)
        .value()
      let labels = _.map(data, 'key')
      let dataSet = _.map(data, 'sum')

      return this.setChartData(labels, dataSet, money)
    },
    getChartData: function(field, specificData) {
      if (specificData == null) specificData = this.filteredData
      let data = _.chain(specificData)
        .groupBy(field)
        .map((items, key) => ({key: key, qtt: items.length}))
        .orderBy(o => o.key)
        .value()
      let labels = _.map(data, 'key')
      let dataSet = _.map(data, 'qtt')

      return this.setChartData(labels, dataSet)
    },

    setChartData: function(labels, dataSet, money) {
      let colors = palette('tol-rainbow', dataSet.length)

      let defaultOptions = {
        maintainAspectRatio: false,
      }

      let moneyOptions = {
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]

              var formatter = new Intl.NumberFormat('fr-CA', {
                style: 'currency',
                currency: 'CAD',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })
              return (
                (data.datasets[tooltipItem.datasetIndex].label != 'data'
                  ? data.datasets[tooltipItem.datasetIndex].label
                  : data.labels[tooltipItem.index]) +
                ' - ' +
                formatter.format(value)
              )
            },
          },
        },
        maintainAspectRatio: false,
      }

      return {
        data: {
          labels: labels,
          datasets: [
            {
              label: 'data',
              data: dataSet,
              backgroundColor: _.map(colors, f => '#' + f),
            },
          ],
        },
        options: money ? moneyOptions : defaultOptions,
      }
    },
    filterPropertyByGreaterInteger: function(data, filter, field) {
      if (data == null) return []
      if (filter == null || filter == '') return data

      return this.filterPropertyByGreaterValue(data, parseInt(filter), field)
    },
    filterPropertyByLesserInteger: function(data, filter, field) {
      if (data == null) return []
      if (filter == null || filter == '') return data

      return this.filterPropertyByLesserValue(data, parseInt(filter), field)
    },
    filterPropertyByGreaterFloat: function(data, filter, field) {
      if (data == null) return []
      if (filter == null || filter == '') return data

      return this.filterPropertyByGreaterValue(data, parseFloat(filter), field)
    },
    filterPropertyByLesserFloat: function(data, filter, field) {
      if (data == null) return []
      if (filter == null || filter == '') return data

      return this.filterPropertyByLesserValue(data, parseFloat(filter), field)
    },
    filterPropertyByGreaterValue: function(data, filter, field) {
      return _.filter(data, x => x[field] <= filter)
    },
    filterPropertyByLesserValue: function(data, filter, field) {
      return _.filter(data, x => x[field] >= filter)
    },
    filterPropertyByList: function(data, filters, field) {
      if (data == null) return []
      if (filters == null || filters.length == 0) return data

      return _.filter(data, x => _.find(filters, f => (f.item1 == x[field] || f.key == x[field]) && x[field] != null))
    },
    filterSubPropertyByList: function(data, filters, field, subField) {
      if (data == null) return []
      if (filters == null || filters.length == 0) return data

      return _.filter(data, x =>
        _.some(x[field], s => _.find(filters, f => (f.item1 == s[subField] || f.key == s[subField]) && s[subField] != null))
      )
    },
    filterSubPropertyByDateTo: function(data, filter, field, subField) {
      if (data == null) return []
      if (filter == null || filter == '') return data

      return _.filter(data, x => _.some(x[field], s => moment(s[subField]).isBefore(filter)))
    },
    filterSubPropertyByDateFrom: function(data, filter, field, subField) {
      if (data == null) return []
      if (filter == null || filter == '') return data

      return _.filter(data, x => _.some(x[field], s => moment(s[subField]).isAfter(filter)))
    },

    filterPropertyByDateTo: function(data, filter, field) {
      if (data == null) return []
      if (filter == null || filter == '') return data

      return _.filter(data, x => x[field] != null && moment(x[field]).isBefore(filter))
    },
    filterPropertyByDateFrom: function(data, filter, field) {
      if (data == null) return []
      if (filter == null || filter == '') return data

      return _.filter(data, x => x[field] != null && moment(x[field]).isAfter(filter))
    },
    expandOrCollapseFilter: function() {
      this.filterVisible = !this.filterVisible
    },
  },
  components: {
    multiselect: Multiselect,
    PieChart: PieChart,
    BarChart: BarChart,
    'moment-date-picker': MomentDatePicker,
  },
}
export default DashboardMixin



// WEBPACK FOOTER //
// ./src/shared/Mixin/DashboardMixin.js